module.exports = __webpack_public_path__ + "img/1-certifications-ml_reg.png";